import { createFileRoute } from "@tanstack/react-router";
import StyleGuidePage from "@/pages/docs/StyleGuidePage";

const title = "QbD Group Design System";
const description =
  "QbD Group design system: tone of voice, messaging, colors, typography, spacing, buttons, forms, navigation, tags, cards, icons and accessibility rules.";

export const Route = createFileRoute("/docs")({
  head: () => ({
    meta: [
      { title },
      { name: "description", content: description },
      { property: "og:title", content: title },
      { property: "og:description", content: description },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
    links: [{ rel: "canonical", href: "https://qbdgroup.com/docs" }],
  }),
  component: StyleGuidePage,
});
